<template>
  <div id="app">
    <!-- 主区域 -->
    <router-view></router-view>
  </div>
</template>

<script>
import { G_WordsConfig, G_ApiConfig } from "./api/api";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // console.log("======================获取文字配置文件======================");
    // G_WordsConfig();
    // console.log("======================获取api配置文件======================");
    // G_ApiConfig();
  },
  mounted() {
 //   this.$store.commit("SetLang", this.$route.query.lang);
    //此方法刷新页面时也会执行 此方法刷新页面时也会执行
    window.addEventListener('beforeunload', () => {
      this.$store.commit("setToken", "");
    });
  }
};
</script>

<style lang="scss">
@import url(./assets/css/site.scss);
</style>



// WEBPACK FOOTER //
// src/App.vue